import { useEffect } from 'react';
import { BROADCAST_CHANNELS, NBN_ORDER_CART_ACTIONS } from '@belong/constants';

export const useNbnCartChange = (onCartChange: (action: string) => void): void => {
  useEffect(() => {
    if (!window.BroadcastChannel) {
      return;
    }

    const channel = new BroadcastChannel(BROADCAST_CHANNELS.NBN_ORDER_CART);

    channel.onmessage = event => {
      const action = event.data?.action;

      if (action === NBN_ORDER_CART_ACTIONS.ADDRESS_CHANGE || action === NBN_ORDER_CART_ACTIONS.CART_ERROR) {
        onCartChange(action);
      }
    };

    return () => {
      channel.close();
    };
  }, [onCartChange]);
};
